'use client';

import { useState, useRef, useEffect } from 'react';
import { Button } from '@heroui/button';
import { Input } from '@heroui/input';
import { addToast } from '@heroui/toast';
import { RegMobie } from '@/utils/regRule';
import * as api from '../api';

interface Props {
  phone?: string;
  setSmsToken: (smsToken: string) => void;
  setSmsCode: (smsCode: string) => void;
}

function useCountdown(callback: () => void, delay: number | null) {
  const savedCallback = useRef<any>(null);

  useEffect(() => {
    savedCallback.current = callback;
  });

  useEffect(() => {
    const tick = () => {
      savedCallback.current();
    };
    if (delay !== null) {
      const id = setInterval(tick, delay || 0);
      return () => clearInterval(id);
    }
  }, [delay]);
}

export default function Index({ phone, setSmsToken, setSmsCode }: Props) {
  const [isRunning, setIsRunning] = useState<boolean>(false);
  const [second, setSecond] = useState(59);

  useCountdown(
    () => {
      setSecond(second - 1);
      if (second <= 0) {
        setIsRunning(false);
        setSecond(59);
      }
    },
    isRunning ? 1000 : null,
  );


  async function sendCode() {
    if (isRunning) {
      addToast({ description: '验证码发送中，请耐心等待！', color: 'warning', icon: 'none', timeout: 2000 });
      return;
    }
    if (!phone || !RegMobie.test(phone)) {
      addToast({ description: '请输入正确的手机号！', color: 'danger', icon: 'none', timeout: 2000 });
      return;
    }
    try {
      const data = await api.verifyCodeApi(phone);
      setSmsToken(data.smsToken);
      setIsRunning(true);
    } catch (e: any) {
      addToast({ description: e?.message, icon: 'none', color: 'danger', timeout: 2000 });
    }
  }

  return (
    <div
      className="w-full flex items-center p-[10px] after:content-['']
      after:block after:absolute after:bottom-0 after:left-0 after:w-full after:h-px after:bg-[rgba(238,238,238,1)] 
      dark:after:bg-[#0a0a0a] after:origin-bottom after:scale-y-50 relative"
    >
      <Input
        radius="none"
        classNames={{
          inputWrapper: 'bg-transparent shadow-none group-data-[focus=true]:bg-transparent',
          label: 'min-w-[70px] text-[15px] text-[#333] dark:text-white',
          mainWrapper: 'w-full',
          base: 'data-[has-helper=true]:items-baseline',
          input: 'group-data-[focus=true]:outline-none',
        }}
        errorMessage="请输入验证码"
        label="验证码"
        labelPlacement="outside-left"
        name="code"
        maxLength={4}
        placeholder="请输入验证码"
        type="text"
        onValueChange={(value: string) => setSmsCode(value)}
      />
      <Button onPress={sendCode} variant="light" className="grow w-auto text-[#4189FD] text-sm">
        {isRunning ? `${second}s后重试` : '获取验证码'}
      </Button>
    </div>
  );
}
